import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export function useScrollableBasket() {
  const [scrollableBasket] = useDecision('turnips_ofx_scrollable_basket_webclient')
  const isAuthenticated = useSelector(getIsAuthenticated)

  return isAuthenticated && scrollableBasket.variationKey === 't1'
}
